//eslint-disable-next-line
import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import accordionMenu from './features/accordion-menu'
import { contactModalToggle } from './features/contactmodal'
import './styles/style.css'

contactModalToggle()
accordionMenu()
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(Draggable)

function scrollGallery() {
  if (window.innerWidth >= 992) {
    // Webflow Reasons Scroll animation
    let galleryScroller = gsap.timeline({
      scrollTrigger: {
        trigger: '#gallery-scroller',
        start: 'top',
        end: 'bottom 0%',
        /*     markers: true, */
        scrub: 2,
        pin: true,
      },
    })

    galleryScroller.to(
      '#gallery-scroller-content',
      { x: '-80%', duration: 1, delay: 0.1, ease: 'linear' },
      0
    )
  }
}
scrollGallery()

// hide scrolldown

let galleryScroller = gsap.timeline({
  scrollTrigger: {
    trigger: '.section_developement-cta',
    start: 'top',
    end: 'bottom 0%',
    /*     markers: true, */
    scrub: 2,
  },
})

galleryScroller.to(
  '.page_scrolldown  , .fs-cc-manager_component',
  { opacity: 0, duration: 1, delay: 0.1, ease: 'linear' },
  0
)

// cards intro

let hideIntro = gsap.timeline({
  scrollTrigger: {
    trigger: '.section_draggable-cards',
    start: 'top 40%',
    toggleActions: 'restart pause none none',
  },
})

hideIntro
  .from('.draggable_cards-arrow-wrapper', {
    opacity: 0,
    y: -100,
    duration: 1,
    ease: 'bounce',
  })
  .to('.draggable_cards-arrow-wrapper', {
    opacity: 0,
    duration: 1,
    delay: 2,
    ease: 'linear',
  })

function revealGalleryInfo() {
  if (window.innerWidth >= 992) {
    gsap.set('.gallery24_info-wrapper', { height: 0, duration: 0.5 })
    gsap.set('.gallery24_hover-message', { opacity: 0 })

    const galleryLinks = document.querySelectorAll('.gallery24_link')
    galleryLinks.forEach((link) => {
      let galleryInfoTl = gsap.timeline({ paused: true })
      let unhideHoverMessage = gsap.to(
        link.querySelector('.gallery24_hover-message'),
        { opacity: 1, paused: true }
      )

      galleryInfoTl.to(link.querySelector('.gallery24_info-wrapper'), {
        height: 'auto',
        duration: 0.3,
      })

      link.addEventListener('mouseenter', () => {
        galleryInfoTl.play()
        unhideHoverMessage.play()
      })
      link.addEventListener('mouseleave', () => {
        galleryInfoTl.reverse()
        unhideHoverMessage.reverse()
      })
    })
  }
}
revealGalleryInfo()

//Draggable Cards

const elementsToRotate = document.querySelectorAll('.reasons_card')

function getRandomRotation() {
  return Math.random() * 10 - 5 // Random rotation between -10 and 10 degrees
}

function setRandomRotation(element) {
  const rotationValue = getRandomRotation()
  element.style.transform = `rotate(${rotationValue}deg)`
}

elementsToRotate.forEach((element) => setRandomRotation(element))

Draggable.create('.reasons_card')
/* export default dragMe */
